// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import ListItemText from '@mui/material/ListItemText';
// routes
import { RouterLink } from 'src/routes/components';
//
import { useGetDashboard } from 'src/api/dashboardapi';
import Badge from '@mui/material/Badge';
import Iconify from '../../iconify';
//
import { NavItemProps, NavConfigProps } from '../types';
import { StyledItem, StyledIcon, StyledDotIcon } from './styles';


// ----------------------------------------------------------------------

type Props = NavItemProps & {
  config: NavConfigProps;
};

export default function NavItem({
  item,
  open,
  depth,
  active,
  config,
  externalLink,
  ...other
}: Props) {
  const { title, path, icon, info, children, disabled, caption, roles } = item;

  // console.log("bvmcxvbmcxbvx",title)

  const subItem = depth !== 1;

  const { dashboarddata } = useGetDashboard();
  const newdata = dashboarddata.map((items: any) => items.totalcount);
  const certificatecount = dashboarddata.map((items: any) => items.certificate_totalcount);

  const insurance: any = newdata[0];
  const certificate: any = certificatecount[0];
  const reported = newdata[1];
// console.log("[[[[[[[[[[certificatecount",certificate,title)
  const renderContent = (
    <StyledItem
      disableGutters
      disabled={disabled}
      active={active}
      depth={depth}
      config={config}
      {...other}
    >
      <>
        {icon && <StyledIcon size={config.iconSize}>{icon}</StyledIcon>}

        {subItem && (
          <StyledIcon size={config.iconSize}>
            {/* <StyledDotIcon active={active} /> */}
          </StyledIcon>
        )}
      </>

       {!(config.hiddenLabel && !subItem) && (
        <ListItemText
          // primary={title}
          primary={
            <div style={{ fontSize: title === 'dashboard' || title === 'revenue' || title === 'Account type' || title === 'Verification' || title === 'Admin'? '15px' : '13px' }}>
              {title}
            </div>
          }
          secondary={
            caption ? (
              <Tooltip title={caption} placement="top-start">
                <span>{caption}</span>
              
              </Tooltip>
            ) : null
          }
          primaryTypographyProps={{
            noWrap: true,
            typography: 'body2',
            textTransform: 'capitalize',
            fontWeight: active ? 'fontWeightSemiBold' : 'fontWeightMedium',
          }}
          secondaryTypographyProps={{
            noWrap: true,
            component: 'span',
            typography: 'caption',
            color: 'text.disabled',
          }}
        />
      )} 

      {info && (
        <Box component="span" sx={{ ml: 1, lineHeight: 0 }}>
          {info}
        </Box>
      )}

      {/* {title === 'insurance' && insurance ? (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // width: '20px',
            // height: '20px',
            borderRadius: '50%',
            background: '#2196F3',
            color: 'white',
            fontSize: '12px',
          }}
        >
          {insurance}
        </div>
      ) : (
        <></>
      )} */}

{title === 'insurance' && insurance ? (
          <Badge badgeContent={insurance} color="primary" max={9999}/>
      ) : (
        <></>
      )}

      {title === 'Certificate' && certificate ? (
          <Badge badgeContent={certificate} color="primary" max={9999}/>
      ) : (
        <></>
      )}

      {/* {title === 'moderated posts' && reported ? (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // width: '20px',
            // height: '20px', 
            borderRadius: '50%',
            background: '#2196F3',
            color: 'white',
            fontSize: '12px',
          }}
        >
          {reported}
        </div>
      ) : (
        <></>
      )} */}



{title === 'moderated posts' && reported ? (
       <Badge badgeContent={reported} color="primary" max={9999}/>
//  {reported}
      //  </Badge>
   
      ) : (
        <></>
      )}

      {!!children && (
        <Iconify
          width={16}
          icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
          sx={{ ml: 1, flexShrink: 0 }}
          // sx={{ ml: 1, flexShrink: 0 , mt:1}}
        />
      )}
    </StyledItem>
  );

  // Hidden item by role
  if (roles && !roles.includes(`${config.currentRole}`)) {
    return null;
  }

  // External link
  if (externalLink)
    return (
      <Link
        href={path}
        target="_blank"
        rel="noopener"
        underline="none"
        color="inherit"
        sx={{
          ...(disabled && {
            cursor: 'default',
          }),
        }}
      >
        {renderContent}
      </Link>
    );

  // Has child
  if (children) {
    return renderContent;
  }

  // Default
  return (
    <Link
      component={RouterLink}
      href={path}
      underline="none"
      color="inherit"
      sx={{
        ...(disabled && {
          cursor: 'default',
        }),
      }}
    >
      
      {renderContent}
    </Link>
  );
}
